import React from 'react'
import Select from '@/Shared/Form/Select';
import { thirdPartyLegalBasisOptions } from '@/lib/settings';
import { useFormContext, useWatch } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import Input from '@/Shared/Form/Input';

const LegalBasis = () => {
  const { formState: { errors } } = useFormContext();
  const [isOtherSelected, setIsOtherSelected] = React.useState(false);
  const thirdPartyLegalBasis = useWatch({ name: 'thirdPartyLegalBasis' });

  React.useEffect(() => {
    if (thirdPartyLegalBasis  === 'Other') {
      setIsOtherSelected(true);
    } else {
      setIsOtherSelected(false);
    }
  }, [thirdPartyLegalBasis]);

  
  return (
    <div className='mt-3'>
      <label className='form-label required'>Legal basis</label>
      <Select
        isRequired
        name='thirdPartyLegalBasis'
        options={thirdPartyLegalBasisOptions}
        getOptionLabel={(option) => option.label}
        getOptionValue={(option) => option.value}
        getOptionEqual={(option) => option.value}
      />
      <ErrorMessage
        errors={errors}
        name='thirdPartyLegalBasis'
        render={({ message }) => (
          <small className='text-danger'>
            {message}
          </small>
        )}
      />
      {isOtherSelected && (
        <div className='mt-3'>
         <Input
          isRequired
          name='thirdPartyCustomLegalBasis'
          labelText='Legal basis description'
          placeholder=''
          />
        </div>
      )}
    </div>
  )
}

export default LegalBasis